import {
    ACTION_GET_LIST_REPORTS,
    ACTION_GET_DOWLOADER_OR_SEND_EMAIL_MONETIZATIONS,
    ACTION_CONFIRM_MONETIZATIONS,
    ACTION_GET_START_MONETIZATIONS,
    ACTION_EMAIL_SEND_MONETIZATION,
    ACTION_POST_HISTORIC_MONETIZATION,
    ACTION_GET_LIST_CONFIRM_MONETIZATION,
    SET_LIST_REPORTS,
    SET_LIST_MONETIZATION,
    SET_CONFIRM_MONETIZATION,
    SET_START_LIST_MONETIZATION,
    SET_EMAIL_SEND_MONETIZATION,
    SET_LIST_CONFIRM_MONETIZATION
} from "@/views/reports/store/types/types.js";

import { reportsService } from "../../../services";

const actions = {

    [ACTION_GET_LIST_REPORTS]: ({ state, commit }) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                reportsService.getListReports(idGroup, companyId, userId)
                    .then(async resp => {
                        commit(SET_LIST_REPORTS, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_START_MONETIZATIONS]: ({ state, commit } ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                reportsService.getListStartMonetizations(idGroup, companyId, userId)
                    .then(async resp => {
                        commit(SET_START_LIST_MONETIZATION, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },

    [ACTION_EMAIL_SEND_MONETIZATION]: ({ state, commit }) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                reportsService.getEmailSend(idGroup, companyId, userId)
                    .then(async resp => {
                        commit(SET_EMAIL_SEND_MONETIZATION, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_DOWLOADER_OR_SEND_EMAIL_MONETIZATIONS]: ({ state, commit }, isDowloader) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                reportsService.generateMonetizationReport(idGroup, companyId, userId, isDowloader)
                    .then(async resp => {
                        commit(SET_LIST_MONETIZATION, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_LIST_CONFIRM_MONETIZATION]: ({ state, commit } ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                reportsService.getListConfirmMonetizations(idGroup, companyId, userId)
                    .then(async resp => {
                        commit(SET_LIST_CONFIRM_MONETIZATION, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },

    [ACTION_CONFIRM_MONETIZATIONS]: ({ state, commit }, data ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                reportsService.postConfirmMonetizations(idGroup, companyId, userId, data)
                    .then(async resp => {
                        commit(SET_CONFIRM_MONETIZATION, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },

    [ACTION_POST_HISTORIC_MONETIZATION]: ({ state }, data ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                reportsService.postHistoricMonetization(idGroup, companyId, userId, data)
                    .then(async resp => {
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },
}

export default actions